(function(G) {
	/**
	 * Creates a modal and returns it. For dynamic use on the frontend.
	 * 
	 * This modal has a header with an X for closing. You can put the title in .modal-title.
	 * You can put the body in .modal-body.
	 * 
	 * Content must be edited manually i.e.:
	 * var $modal = G.createModal('test-modal');
	 * $modal.find('.modal-title').html('Test Modal Title');
	 * $modal.find('.modal-body').html('Test Modal Body');
	 * 
	 * or 
	 * 
	 * G.modal($modal, {'title': 'Some Title', 'body': '<span>Some Body</span>'})
	 * 
	 * @param {string} modalID The ID of the modal to be created
	 * @param {string} size (optional) The size of the modal to be created from: modal-sm, {'' for regular size}, modal-lg, modal-xl
	 */
	G.createModal = function(modalID, size) {
		if(!$('#' + modalID).length) {
			$('body').append('\
			<div id="' + modalID + '" class="modal fade" role="dialog">\
				<div class="modal-dialog ' + size + '" role="document">\
					<div class="modal-content">\
						<div class="modal-header">\
							<h5 class="modal-title" data-bind-html="title"></h5>\
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">\
								<span aria-hidden="true">&times;</span>\
							</button>\
						</div>\
						<div class="modal-body" data-bind-html="body"></div>\
					</div>\
				</div>\
			</div>\
			');
		}
		return $('#' + modalID);
	}
	
	/**
	 * This type of modal is just a blank canvas. it does not have the header or any footer like the above.
	 */
	G.createBlankModal = function(modalID, size) {
		if(!$('#' + modalID).length) {
			$('body').append('\
			<div id="' + modalID + '" class="modal fade" role="dialog">\
				<div class="modal-dialog ' + size + '" role="document">\
					<div class="modal-content">\
						<div class="modal-body"></div>\
					</div>\
				</div>\
			</div>\
			');
		}
		return $('#' + modalID);
	}
	
	// show a popup without confirm buttons or icon, etc.
	G.modalPopup = function(title, contents) {
		var $modal = G.createModal('graphite-modal-popup');
		
		$modal.find('.modal-title').html(title);
		$modal.find('.modal-body').html(contents);
		
		$modal.modal('show');
		
		return $modal;
	}

	/**
	* shows a modal and binds data to it.
	* 
	* @param str selector the modal to show
	* @param obj data data to bind to the modal
	* @return void
	*/
	G.modal =  function(selector, data){
		var $modal = $(selector);
		if(!$modal.length){
			throw new Error('Could not find modal '+selector);
		}
		this.bind(selector, data);
		$modal.modal('show');
		$modal.find('[data-toggle="tooltip"]').tooltip();
	}
})(window.G);